export default "__VITE_PUBLIC_ASSET__c2ee4d73__"